<template>
  <slot />
</template>

<script setup>
definePageMeta({
  middleware: 'activate-page',
})
</script>
